export const NavIndex = Object.freeze({
  Eqiup: 0,
  BroadsideBattle: 1,
  VsBattle: 2,
  Kitchen: 3,
  Shop: 4,
})